



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class ViewPageViewsModal extends Vue {
  showModal = false
  @Prop() views?: any[];
  @Prop() pageViews?: any[];
  @Prop() eventType?: number;

  items: any[] = []

  @Watch('views')
  mapViewsToPageViews () {
    if (this.eventType === 16) {
      this.detailFields = [{ key: 'description', label: 'Description', sortable: true }, { key: 'duration', label: 'Duration (in min)', class: 'text-center', formatter: (value: number) => this.formatDetailDuration(value) }]
      this.fields = [{ key: 'productName', name: 'Product Name', class: 'font-bold' }, { key: 'title' }, { key: 'reportCount', label: 'Reports generated', class: 'text-center' }, { key: 'show_details', label: 'View Time', class: 'text-right' }]
    }

    if (this.views) {
      const results = this.views.map((view: any) => {
        const pageViews = this.mapPageViews(this.pageViews?.filter((pageView: any) => pageView.trackingkey === view.trackingkey).map((pageView: any) => {
          return pageView.pageviews
        }) || [])
        return {
          productName: view.productname,
          title: view.title,
          trackingKey: view.trackingkey,
          count: parseInt(view.count),
          reportCount: view.eventtype === 16 ? view.reportcount : 0,
          totalTime: this.formatDuration(view.eventtype === 16 ? Math.ceil(view.totaltime / 60000) : pageViews.map((pageView: any) => pageView.duration).reduce((a: number, b: number) => a + b, 0)),
          pageViews: view.eventtype === 16 ? this.mapWebAppViews(view.pageviews) : pageViews
        }
      })
      console.log(this.items)
      this.items = results.filter((result: any) => result.pageViews.length).sort((a, b) => b.totalTime - a.totalTime || a.productName - b.productName)
    }
  }

  fields:any[] = [{ key: 'productName', name: 'Product Name', class: 'font-bold' }, { key: 'title' }, { key: 'show_details', label: 'View Time', class: 'text-right' }]
  detailFields:any[] = [{ key: 'pageNo', label: 'Page No.', sortable: true, class: 'text-center' }, { key: 'sectionName', label: 'Section', sortable: true }, { key: 'duration', label: 'Duration (in min)', class: 'text-center', formatter: (value: number) => this.formatDetailDuration(value) }]

  formatDuration (duration: number) {
    if (this.eventType === 16) {
      return Math.ceil(duration)
    } else {
      return Math.ceil(duration / 10)
    }
  }

  formatDetailDuration (duration: number) {
    if (this.eventType === 16) {
      if (duration / 60 < 1) {
        return '< ' + Math.ceil(duration / 60)
      } else {
        return Math.ceil(duration / 60)
      }
    } else {
      if (duration / 10 < 1) {
        return '< ' + Math.ceil(duration / 10)
      } else {
        return Math.ceil(duration / 10)
      }
    }
  }

  mapWebAppViews (views: any[]) {
    // get list of unique keys from the views
    const uniqueKeys = Array.from(new Set(views.map((view: any) => view.key)))
    const mappedViews: any[] = []
    uniqueKeys.forEach((key: any) => {
      const filteredViews = views.filter((view: any) => view.key === key)
      let totalDuration = 0
      filteredViews.forEach((view: any) => {
        totalDuration += view.duration
      })
      mappedViews.push({
        key: key,
        duration: totalDuration,
        description: filteredViews[0].description
      })
    })
    return mappedViews.sort((a: any, b: any) => b.duration - a.duration || a.key - b.key)
  }

  mapPageViews (pageViews: any[]) {
    const views: any[] = []
    const tmpViews: any[] = []
    const tmp = pageViews.map((pageView: any) => {
      return pageView.map((view: any) => {
        return {
          pageNo: view.pageNo,
          title: view.title,
          sectionName: view.sectionName,
          duration: view.duration
        }
      })
    })
    tmp.forEach((view: any) => {
      tmpViews.push(...view)
    })
    // get unique page numbers from the tmpViews
    const uniquePageNumbers = Array.from(new Set(tmpViews.map((view: any) => view.pageNo)))
    uniquePageNumbers.forEach((pageNumber: any) => {
      let viewTime: number = 0
      const pageViews = tmpViews.filter((view: any) => view.pageNo === pageNumber)
      if (pageViews.length) {
        pageViews.forEach((view: any) => {
          viewTime += view.duration
        })

        views.push({
          pageNo: pageNumber,
          title: pageViews[0].title,
          sectionName: pageViews[0].sectionName,
          duration: viewTime / 6000 // updated to seconds
        })
      }
    })

    // sort views by duration and page number. Duration should be the mane sort. Then if the duration is the same, sort by page number
    return views.sort((a, b) => b.duration - a.duration || a.pageNo - b.pageNo)
  }
}
